<div class="container">
  <h2 class="title text-center">Cursos em oferta experimental</h2>
  <p class="text-justify">
    Cursos em oferta experimental são cursos inovadores, demandados pelo mundo do trabalho, que já
    estão sendo ofertados, mas ainda não integram o Catálogo pois não foram analisados pelo MEC. Sua
    inserção no Catálogo depende da aprovação pelo Ministério e não é certa.
  </p>
  <p class="text-justify">
    Sua oferta é regulamentada pela
    <a
      class="link custom-link"
      href="http://portal.mec.gov.br/index.php?option=com_docman&view=download&alias=16705-res1-2014-cne-ceb-05122014&category_slug=dezembro-2014-pdf&Itemid=30192"
      >Resolução CNE/CEB nº 01/2014</a
    >.
  </p>
  <br />
  <a
    routerLink="/cursos"
    [queryParams]="{ filtro: 'experimentais' }"
    class="btn-primary link btn btn-xl rounded-pill text-center"
    >Ir para esses cursos</a
  >
</div>
